<script lang="ts">
    import { location } from "../store"

    let oldPath: string
    $: if (typeof window !== "undefined" && oldPath !== $location.path) {
        const ref = oldPath ? document.location.protocol + "//" + document.location.host + oldPath : document.referrer
        oldPath = $location.path
        if ($location.search) oldPath += $location.search
        fetch(oldPath, {
            headers: {
                "x-ssr-skip": "204",
                "x-ssr-ref": ref,
                "x-ssr-res": `${window.innerWidth}x${window.innerHeight}`,
                // no cache
                "cache-control": "no-cache, no-store, must-revalidate",
            },
        })
    }
</script>
